import { type FC, type ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ESpinnerSize, ErrorHint, Loadable, Spinner } from "@/3514/components"
import { ParticipantLayout } from "@/3514/layouts"

import { ParticipantSwapSessionContainer as Container } from "./participant.swap-session.container"

const SwapSessionPage: FC = (): ReactElement => (
    <ParticipantLayout withHtmlScrollBarGutter>
        <ErrorBoundary fallback={<ErrorHint isVisible />}>
            <Loadable
                component={Container}
                loadingFallback={<Spinner size={ESpinnerSize.Medium} wrapperClassName="top-[120px] relative" />}
                withEnforcedSuspense
            />
        </ErrorBoundary>
    </ParticipantLayout>
)

SwapSessionPage.displayName = "ParticipantSwapSessionPage"

export { SwapSessionPage as ParticipantSwapSessionPage }
